interface BuildPageHrefParams {
	page: number
	pathname: string
	searchParams: URLSearchParams
}

/**
 * Формирует href для страницы пагинации
 * Учитывает query params текущего URL
 */
export const buildPageHref = ({ page, pathname, searchParams }: BuildPageHrefParams): string => {
	const params = new URLSearchParams(searchParams)

	// Страница 1 — без параметра page
	if (page === 1) {
		params.delete('page')
	} else {
		params.set('page', page.toString())
	}

	const queryString = params.toString()

	return queryString ? `${pathname}?${queryString}` : pathname
}
